/* GEBBLO G-Block product-page URL preset selector.
   Reads ?gebblo_depth=single|double&gebblo_size=2.5x3.3|2.7x3.7,
   then selects matching YMQ options after the app has rendered. */
(() => {
  const params = new URLSearchParams(window.location.search);
  const depth = params.get('gebblo_depth');
  const size = params.get('gebblo_size');
  const presets = {
    single: { depth: ['single', 'layer'], size: ['2.5', '3.3'] },
    double: { depth: ['double', 'layer'], size: ['2.7', '3.7'] }
  };
  const preset = presets[depth];
  if (!preset || !size) return;

  const normalise = (value) => String(value || '').toLowerCase().replace(/\s+/g, ' ');
  const includesAll = (value, parts) => {
    const text = normalise(value);
    return parts.every((part) => text.includes(part));
  };
  const optionBox = (label) => Array.from(document.querySelectorAll('ymq-option,[ymq-option-label]'))
    .find((element) => normalise(element.getAttribute('ymq-option-label')).includes(label));
  const fireChange = (element) => {
    element.dispatchEvent(new Event('input', { bubbles: true }));
    element.dispatchEvent(new Event('change', { bubbles: true }));
  };

  function setDepth(box) {
    const label = Array.from(box.querySelectorAll('label'))
      .find((element) => includesAll(element.textContent, preset.depth));
    if (!label) return false;
    const input = label.querySelector('input[type="radio"]');
    if (input && !input.checked) input.click();
    else label.click();
    return true;
  }

  function setSize(box) {
    const select = box.querySelector('select');
    if (select) {
      const choice = Array.from(select.options).find((option) => includesAll(option.textContent, preset.size));
      if (!choice) return false;
      select.value = choice.value;
      fireChange(select);
      return true;
    }
    const choice = Array.from(box.querySelectorAll('label,button,[role="option"],.ymq-option-value-item'))
      .find((element) => includesAll(element.textContent, preset.size));
    if (!choice) return false;
    choice.click();
    return true;
  }

  let attempts = 0;
  const applyPreset = () => {
    const depthBox = optionBox('choose frame depth');
    const sizeBox = optionBox('choose enclosure size');
    if (depthBox) setDepth(depthBox);
    if (sizeBox && setSize(sizeBox)) return;
    if (attempts++ < 20) window.setTimeout(applyPreset, 300);
  };

  applyPreset();
})();
